import { render } from "./FormDateTime.vue?vue&type=template&id=15d38128"
import script from "./FormDateTime.vue?vue&type=script&lang=js"
export * from "./FormDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__